<div class="d-flex justify-content-between align-items-center mb-3">
    <h3 class="mb-0">Receiving</h3>
    @if (canEdit) {
        <button class="btn btn-primary btn-sm" (click)="startNew()">+ New Receipt</button>
    }
</div>

<input #slipInput type="file" class="d-none" accept=".pdf,.png,.jpg,.jpeg,.docx,.xlsx" (change)="onSlipFileSelected($event)" />
<input #docInput type="file" class="d-none" multiple (change)="onDocFileSelected($event)" />

<div class="row g-3">
    <div class="col-lg-5">
        <div class="purchasing-table-panel">
                <table class="table table-sm table-hover mb-0 receipt-list">
                    <thead>
                        <tr>
                            <th>Receipt #</th>
                            <th>PO #</th>
                            <th>Vendor</th>
                            <th>Date</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (receipt of receipts; track receipt.id) {
                            <tr (click)="selectReceipt(receipt)" [class.table-active]="selectedReceipt?.id === receipt.id" style="cursor: pointer">
                                <td>{{ receipt.receiptNumber }}</td>
                                <td>
                                    <a [routerLink]="['/purchasing/purchase-orders']" (click)="$event.stopPropagation()">{{ receipt.poNumber }}</a>
                                </td>
                                <td>{{ receipt.vendorName }}</td>
                                <td>{{ receipt.receivedDate | date: 'shortDate' }}</td>
                                <td><span class="badge" [ngClass]="statusBadgeClass(receipt.status)">{{ receipt.status }}</span></td>
                            </tr>
                        }
                        @if (receipts.length === 0) {
                            <tr>
                                <td colspan="5" class="text-center text-muted py-3">No receiving records yet.</td>
                            </tr>
                        }
                    </tbody>
                </table>
        </div>
    </div>
    <div class="col-lg-7">
        @if (editing && editModel) {
            <div class="card">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <span>{{ creating ? 'New Receipt' : 'Edit Receipt' }}</span>
                    @if (canEdit && (selectedOrderId || editModel.purchaseOrderId)) {
                        <button class="btn btn-outline-secondary btn-sm" (click)="triggerSlipScan()" [disabled]="isProcessingAi">
                            @if (isProcessingAi) {
                                <span class="spinner-border spinner-border-sm me-1"></span>
                            }
                            Scan Packing Slip (AI)
                        </button>
                    }
                </div>
                <div class="card-body">
                    <div class="row g-2 mb-3">
                        <div class="col-md-6">
                            <label class="form-label small mb-0">Purchase Order</label>
                            <select class="form-select form-select-sm" [(ngModel)]="selectedOrderId" (ngModelChange)="onOrderSelected()" [disabled]="!creating">
                                <option value="">-- Select PO --</option>
                                @for (po of openOrders; track po.id) {
                                    <option [value]="po.id">{{ po.poNumber }} - {{ po.vendorName }}{{ po.equipment ? ' / ' + po.equipment : '' }}{{ po.workOrder ? ' / WO ' + po.workOrder : '' }}</option>
                                }
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label small mb-0">Receipt #</label>
                            <input class="form-control form-control-sm" [(ngModel)]="editModel.receiptNumber" placeholder="Auto if blank" />
                        </div>
                        <div class="col-md-3">
                            <label class="form-label small mb-0">Received Date</label>
                            <input type="date" class="form-control form-control-sm" [(ngModel)]="editModel.receivedDate" />
                        </div>
                        <div class="col-md-6">
                            <label class="form-label small mb-0">Storage Place</label>
                            <input class="form-control form-control-sm" [(ngModel)]="editModel.storagePlace" />
                        </div>
                        <div class="col-12">
                            <label class="form-label small mb-0">Notes</label>
                            <textarea class="form-control form-control-sm" rows="2" [(ngModel)]="editModel.notes"></textarea>
                        </div>
                    </div>

                    <h6>Line Items</h6>
                    <div class="table-responsive">
                        <table class="table table-sm align-middle line-item-table">
                            <thead>
                                <tr>
                                    <th>Description</th>
                                    <th class="text-end">Ordered</th>
                                    <th class="text-end">Received</th>
                                    <th class="text-end">Remaining</th>
                                    <th class="text-end" style="width: 90px">Receive Now</th>
                                    <th style="width: 90px">Issue</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (line of editModel.lineItems; track $index) {
                                    <tr [ngClass]="lineReceiveClass(line)">
                                        <td>{{ line.description }}</td>
                                        <td class="text-end">{{ line.quantityOrdered }}</td>
                                        <td class="text-end">{{ line.quantityReceivedToDate }}</td>
                                        <td class="text-end">{{ line.quantityRemaining }}</td>
                                        <td>
                                            <input type="number" class="form-control form-control-sm text-end" [(ngModel)]="line.quantityReceived" min="0" />
                                        </td>
                                        <td>
                                            <select class="form-select form-select-sm" [(ngModel)]="line.issueType">
                                                @for (t of issueTypes; track t) {
                                                    <option [value]="t">{{ t }}</option>
                                                }
                                            </select>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="card-footer d-flex justify-content-end gap-2">
                    <button class="btn btn-outline-secondary btn-sm" (click)="cancelEdit()">Cancel</button>
                    <button class="btn btn-primary btn-sm" (click)="save()" [disabled]="isSaving">
                        @if (isSaving) {
                            <span class="spinner-border spinner-border-sm me-1"></span>
                        }
                        Save & Post
                    </button>
                </div>
            </div>
        } @else if (selectedReceipt) {
            <div class="card">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <span>
                        {{ selectedReceipt.receiptNumber }}
                        <span class="badge ms-2" [ngClass]="statusBadgeClass(selectedReceipt.status)">{{ selectedReceipt.status }}</span>
                    </span>
                    @if (canEdit) {
                        <div class="d-flex gap-2">
                            <button class="btn btn-outline-primary btn-sm" (click)="startEdit()">Edit</button>
                            @if (hasDiscrepancies(selectedReceipt)) {
                                <button class="btn btn-outline-warning btn-sm" (click)="openOverageEmail()">Email Vendor</button>
                            }
                            <button class="btn btn-outline-secondary btn-sm" (click)="triggerDocUpload()">Upload Doc</button>
                            <button class="btn btn-outline-danger btn-sm" (click)="deleteReceipt(selectedReceipt)">Archive</button>
                        </div>
                    }
                </div>
                <div class="card-body">
                    <dl class="row mb-2 small">
                        <dt class="col-sm-3">PO</dt>
                        <dd class="col-sm-9">
                            <a [routerLink]="['/purchasing/purchase-orders']">{{ selectedReceipt.poNumber || '—' }}</a>
                        </dd>
                        <dt class="col-sm-3">Vendor</dt>
                        <dd class="col-sm-9">{{ selectedReceipt.vendorName || '—' }}</dd>
                        <dt class="col-sm-3">Equipment</dt>
                        <dd class="col-sm-9">{{ selectedReceipt.equipment || '—' }}</dd>
                        <dt class="col-sm-3">Work Order</dt>
                        <dd class="col-sm-9">{{ selectedReceipt.workOrder || '—' }}</dd>
                        <dt class="col-sm-3">Received Date</dt>
                        <dd class="col-sm-9">{{ (selectedReceipt.receivedDate | date: 'shortDate') || '—' }}</dd>
                        <dt class="col-sm-3">Storage</dt>
                        <dd class="col-sm-9">{{ selectedReceipt.storagePlace || '—' }}</dd>
                    </dl>

                    <div class="d-flex gap-3 small text-muted mb-3">
                        <span>{{ selectedReceipt.lineItemCount || selectedReceipt.lineItems.length || 0 }} line(s)</span>
                        @if (selectedReceipt.invoiceCount > 0) {
                            <span>
                                <a [routerLink]="['/purchasing/invoicing']" [queryParams]="{ orderId: selectedReceipt.purchaseOrderId }">{{ selectedReceipt.invoiceCount }} invoice(s)</a>
                            </span>
                        }
                    </div>

                    <h6>Line Items</h6>
                    <div class="table-responsive">
                        <table class="table table-sm mb-3">
                            <thead>
                                <tr>
                                    <th>Description</th>
                                    <th class="text-end">Ordered</th>
                                    <th class="text-end">Received (total)</th>
                                    <th class="text-end">This Receipt</th>
                                    <th>Issue</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (line of selectedReceipt.lineItems; track line.id) {
                                    <tr [ngClass]="{
                                        'table-danger': (line.issueType || '').toLowerCase() === 'over' || (line.issueType || '').toLowerCase() === 'damaged',
                                        'table-warning': (line.issueType || '').toLowerCase() === 'short',
                                    }">
                                        <td>{{ line.description }}</td>
                                        <td class="text-end">{{ line.quantityOrdered }}</td>
                                        <td class="text-end">{{ line.quantityReceivedToDate }}</td>
                                        <td class="text-end">{{ line.quantityReceived }}</td>
                                        <td>{{ line.issueType }}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>

                    @if (selectedReceipt.documents && selectedReceipt.documents.length > 0) {
                        <h6>Documents</h6>
                        <ul class="list-unstyled small">
                            @for (doc of selectedReceipt.documents; track doc.id) {
                                <li>
                                    <a [href]="documentUrl(doc)" target="_blank">{{ doc.fileName }}</a>
                                    <span class="text-muted">({{ doc.documentType }})</span>
                                </li>
                            }
                        </ul>
                    }
                </div>
            </div>
        } @else {
            <div class="text-muted p-4 text-center border rounded">Select a receipt to view details, or create a new one from a purchase order.</div>
        }
    </div>
</div>

@if (emailing) {
    <div class="modal-backdrop-custom" (click)="emailing = false"></div>
    <div class="modal-dialog-custom">
        <div class="card">
            <div class="card-header">Email Vendor About Discrepancies</div>
            <div class="card-body">
                <div class="mb-2">
                    <label class="form-label small mb-0">To Email</label>
                    <input class="form-control form-control-sm" [(ngModel)]="emailModel.toEmail" />
                </div>
                <div class="mb-2">
                    <label class="form-label small mb-0">CC Email</label>
                    <input class="form-control form-control-sm" [(ngModel)]="emailModel.ccEmail" />
                </div>
                <div class="mb-2">
                    <label class="form-label small mb-0">Subject</label>
                    <input class="form-control form-control-sm" [(ngModel)]="emailModel.subject" />
                </div>
                <div class="mb-2">
                    <label class="form-label small mb-0">Message</label>
                    <textarea class="form-control form-control-sm" rows="3" [(ngModel)]="emailModel.message"></textarea>
                </div>
            </div>
            <div class="card-footer d-flex justify-content-end gap-2">
                <button class="btn btn-outline-secondary btn-sm" (click)="emailing = false">Cancel</button>
                <button class="btn btn-primary btn-sm" (click)="sendOverageEmail()" [disabled]="!emailModel.toEmail">Send</button>
            </div>
        </div>
    </div>
}
